const toCapitelizeCase = (value: string): string => value.split('-').map(s => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()).join('-');

export {
  toCapitelizeCase
}



// WEBPACK FOOTER //
// ./src/tools/tocapitalizecase.ts